import _ from "lodash";
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

//- material ui
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { getGlobalClasses } from "../../themes";
import Grid from "@material-ui/core/Grid";

import ListSubheader from "@material-ui/core/ListSubheader";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

//- icons
import RemoveIcon from "@material-ui/icons/Remove";
import TruckIcon from "@material-ui/icons/LocalShipping";
import CityIcon from "@material-ui/icons/LocationCity";
import SwapHoriz from "@material-ui/icons/SwapHoriz";
import DateIcon from "@material-ui/icons/CalendarToday";
import TimeIcon from "@material-ui/icons/AccessTime";
import NotesIcon from "@material-ui/icons/Notes";
import PersonIcon from "@material-ui/icons/Person";
import ListIcon from "@material-ui/icons/List";
import TitleIcon from "@material-ui/icons/Title";
import UploadIcon from "@material-ui/icons/Backup";
import CheckboxIcon from "@material-ui/icons/CheckBox";

//- drag and drop
import Card from "./Card";
import update from "immutability-helper";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

//- ui
import FormSubmitButton from "../../components/form/FormSubmitButton";
import FormText from "../../components/form/FormText";
import SectionHeader from "../../components/SectionHeader";

//- containers
import TicketSchemaContainer from "../../containers/Ticket/TicketSchema";
import SavingDialog from "../../components/dialogs/SavingDailog";
import AuthUserContainer from "../../containers/AuthUser";
//import FormContainer from "../../components/FormContainer";

const _randId = () => {
  return _.times(20, () => _.random(35).toString(36)).join("");
};

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: "0px 10px 0px 10px",
  //margin: `0 0 ${grid}px 0`,
  transition: "0.3s",

  // change background colour if dragging
  //background: isDragging ? "light green" : "#fff",
  backgroundColor: isDragging
    ? `rgba(6, 126, 253, .3)`
    : `rgba(6, 126, 253, 0)`,
  ...draggableStyle,
});

const styles = (theme) => {
  return {
    ...getGlobalClasses(theme),
    itemContainer: {
      position: "relative",
    },
    notDoneYet: {
      opacity: 0.3,
    },
  };
};

const idField = "ticketSchemaId";
const itemDisplay = "Ticket Schema";

class SchemaBuilder extends Component {
  constructor(props) {
    super(props);

    const action = _.get(this.props, "match.params.action");
    const id = parseInt(_.get(this.props, `match.params.${idField}`), 10);
    const isUpdate = action === "update";

    this.state = {
      [idField]: id,
      isUpdate,

      formFieldError: {},
      isSavingOpen: false,
      savingStatus: undefined,

      items: [{ id: _randId(), type: "text" }],
    };
  }

  componentDidMount() {
    const { ticketSchema, getTicketSchema } = this.props;
    const { ticketSchemaId, isUpdate } = this.state;
    if (!isUpdate) {
      return;
    }

    if (ticketSchema) {
      this.fillForm({ ticketSchema });
    } else {
      getTicketSchema({
        params: { ticketSchemaIds: [ticketSchemaId] },
      });
    }
  }

  componentDidUpdate(prevProps, prevState, snapShot) {
    const { ticketSchema } = this.props;

    if (_.isUndefined(prevProps.ticketSchema) && !_.isUndefined(ticketSchema)) {
      this.fillForm({ ticketSchema });
    }
  }

  fillForm = ({ ticketSchema }) => {
    if (!ticketSchema) {
      return;
    }

    const newState = {};
    ["displayName"].forEach((key) => {
      if (_.isNil(ticketSchema[key])) {
        return;
      }
      newState[key] = ticketSchema[key];
    });

    const { items } = ticketSchema;
    newState.items = items;

    this.setState(newState);
  };

  onChange = (value, path, error) => {
    const arrayPath = _.toPath(path);
    const basePath = _.head(arrayPath);
    let base = this.state[basePath];
    let newState = {};

    if (_.isArray(base) || _.isObject(base)) {
      if (arrayPath.length > 1) {
        base = _.cloneDeep(base);
        _.set(base, arrayPath.slice(1), value);
        newState[basePath] = base;
      } else {
        newState[basePath] = value;
      }
    } else {
      newState[basePath] = value;
    }

    //- Clear any errors on the path
    let formFieldError = Object.assign({}, this.state.formFieldError);

    if (error) {
      formFieldError[path] = error;
    } else {
      delete formFieldError[path];
    }
    newState.formFieldError = formFieldError;
    this.setState(newState);
  };

  closeSavingDialog = () => {
    this.setState({ onContinue: false });
  };

  continueSavingDialog = () => {
    this.props.history.push(`/ticketSchema/list`);
  };

  //
  //- drag drop form section
  //
  createItemHandler = (type) => {
    return () => {
      if (type === "select") {
        return;
      }
      return this.addItem({ type });
    };
  };

  addItem = (item) => {
    item.id = _randId();
    //item.label = _randId();
    const { items } = this.state;
    this.setState({
      items: items.concat(item),
    });
  };

  removeItem = (index) => {
    const items = [...this.state.items]; // make a separate copy of the array
    items.splice(index, 1);
    this.setState({ items });
  };

  onCardSettingsChange = ({ settings, index }) => {
    const toMerge = {};
    settings.forEach(({ path, value }) => {
      toMerge[path] = value;
    });

    const newState = update(this.state, {
      items: {
        [index]: {
          $merge: toMerge,
        },
      },
    });
    this.setState(newState);
  };

  onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = reorder(
      this.state.items,
      result.source.index,
      result.destination.index
    );

    this.setState({
      items,
    });
  };

  //
  //- drag drop form section
  //

  handleSave = () => {
    const { addTicketSchema, updateTicketSchema, showErrors } = this.props;

    const { isUpdate, ticketSchemaId } = this.state;

    const formFieldError = {};

    const requiredFields = [{ path: "displayName", label: "Name" }];

    requiredFields.forEach(({ path, label }) => {
      if (!this.state[path]) {
        formFieldError[path] = `${label} is required`;
      }
    });

    const { displayName, items } = this.state;

    if (_.isEmpty(items)) {
      formFieldError.items = `You must have at least one form field`;
    }

    //- Get all the values and do individual checks
    if (_.keys(formFieldError).length) {
      this.setState({ formFieldError });
      showErrors(_.values(formFieldError));
      return;
    }

    const params = {
      displayName,
      items,
    };

    this.setState({
      isSavingOpen: true,
      savingStatus: "saving",
    });

    if (!isUpdate) {
      addTicketSchema({
        params,
        callback: this.postSave,
      });
    } else {
      params.ticketSchemaId = ticketSchemaId;
      updateTicketSchema({
        params,
        callback: this.postSave,
      });
    }
  };

  postSave = (err) => {
    _.delay(() => {
      const { showErrors } = this.props;
      if (err) {
        this.setState({ isSavingOpen: false });
        return showErrors(_.isArray(err) ? err : [err]);
      }
      this.setState({
        savingStatus: "done",
      });
    }, 250);
  };

  getInputProps = (path, defaultValue) => {
    return {
      key: path,
      path,
      value: this.getValue(path, defaultValue),
      checked: this.getValue(path, defaultValue),
      error: this.getError(path),
      onChange: this.onChange,
    };
  };

  getValue = (path, defaultValue) => {
    const _d = _.isUndefined(defaultValue) ? "" : defaultValue;
    return _.get(this.state, path, _d);
  };

  getError = (path) => {
    return _.get(this.state.formFieldError, path);
  };

  render() {
    const { classes } = this.props;

    const { isSavingOpen, savingStatus, isUpdate } = this.state;
    const action = isUpdate ? "Update" : "Create";

    return (
      <Fragment>
        <div className={classes.globalMainHeadline}>
          {action} {itemDisplay}
        </div>
        <Grid spacing={2} container>
          <Grid item xs={12} sm={12} md={9}>
            <Paper
              className={classes.globalMainPaper}
              style={{ position: "relative" }}
            >
              <Grid spacing={2} container>
                <Grid item xs={12} sm={12} md={12} lg={11}>
                  <FormText
                    label={"Name of Schema"}
                    {...this.getInputProps("displayName")}
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={11}>
                  <SectionHeader label={"Form Builder"} />
                  <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable droppableId="droppable">
                      {(provided) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          //style={getListStyle(snapshot.isDraggingOver)}
                        >
                          {this.state.items.map((item, index) => (
                            <Draggable
                              key={item.id}
                              draggableId={item.id}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  style={getItemStyle(
                                    snapshot.isDragging,
                                    provided.draggableProps.style
                                  )}
                                >
                                  <Card
                                    item={item}
                                    remove={() => {
                                      this.removeItem(index);
                                    }}
                                    onSettingsChange={(settings) => {
                                      this.onCardSettingsChange({
                                        index,
                                        settings,
                                      });
                                    }}
                                    dragHandleProps={provided.dragHandleProps}
                                  />
                                </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </Grid>
              </Grid>

              <FormSubmitButton
                onClick={this.handleSave}
                buttonText={`${action} ${itemDisplay}`}
              />
            </Paper>
          </Grid>

          <Grid item xs={12} sm={12} md={3}>
            <Paper>
              <List
                component="nav"
                subheader={
                  <ListSubheader component="div">Click to add</ListSubheader>
                }
                className={classes.root}
              >
                <ListItem button onClick={this.createItemHandler("text")}>
                  <ListItemIcon>
                    <RemoveIcon />
                  </ListItemIcon>
                  <ListItemText inset primary="Single-line Text" />
                </ListItem>

                <ListItem button onClick={this.createItemHandler("textArea")}>
                  <ListItemIcon>
                    <NotesIcon />
                  </ListItemIcon>
                  <ListItemText inset primary="Multi-line Text" />
                </ListItem>

                <ListItem button onClick={this.createItemHandler("checkbox")}>
                  <ListItemIcon>
                    <CheckboxIcon />
                  </ListItemIcon>
                  <ListItemText inset primary="Checkbox" />
                </ListItem>

                <ListItem button onClick={this.createItemHandler("tmwOrderId")}>
                  <ListItemIcon>
                    <SwapHoriz />
                  </ListItemIcon>
                  <ListItemText inset primary="TMW Order Id" />
                </ListItem>

                <ListItem button onClick={this.createItemHandler("datePicker")}>
                  <ListItemIcon>
                    <DateIcon />
                  </ListItemIcon>
                  <ListItemText inset primary="Date Picker" />
                </ListItem>

                <ListItem button onClick={this.createItemHandler("timePicker")}>
                  <ListItemIcon>
                    <TimeIcon />
                  </ListItemIcon>
                  <ListItemText inset primary="Time Picker" />
                </ListItem>

                <ListItem button onClick={this.createItemHandler("userPicker")}>
                  <ListItemIcon>
                    <PersonIcon />
                  </ListItemIcon>
                  <ListItemText inset primary="Employee Picker" />
                </ListItem>

                <ListItem
                  button
                  onClick={this.createItemHandler("fleetDepartmentPicker")}
                >
                  <ListItemIcon>
                    <CityIcon />
                  </ListItemIcon>
                  <ListItemText inset primary="Fleet / Department Picker" />
                </ListItem>

                <ListItem
                  button
                  onClick={this.createItemHandler("fleetPicker")}
                >
                  <ListItemIcon>
                    <TruckIcon />
                  </ListItemIcon>
                  <ListItemText inset primary="Fleet Picker" />
                </ListItem>

                <ListItem
                  button
                  onClick={this.createItemHandler("sectionHeader")}
                >
                  <ListItemIcon>
                    <TitleIcon />
                  </ListItemIcon>
                  <ListItemText inset primary="Section Header" />
                </ListItem>

                <ListItem
                  button
                  onClick={this.createItemHandler("fileUploader")}
                >
                  <ListItemIcon>
                    <UploadIcon />
                  </ListItemIcon>
                  <ListItemText inset primary="File Uploader" />
                </ListItem>

                <ListItem
                  button
                  onClick={this.createItemHandler("select")}
                  className={classes.notDoneYet}
                >
                  <ListItemIcon>
                    <ListIcon />
                  </ListItemIcon>
                  <ListItemText inset primary="Dropdown Picker" />
                </ListItem>
              </List>
            </Paper>
          </Grid>
        </Grid>

        <SavingDialog
          open={isSavingOpen}
          onClose={this.closeSavingDialog}
          onContinue={this.continueSavingDialog}
          processingText={
            isUpdate ? `Updating ${itemDisplay}` : `Creating New ${itemDisplay}`
          }
          successText={`${itemDisplay} saved successfully. Thank you.`}
          status={savingStatus}
        />
      </Fragment>
    );
  }
}

SchemaBuilder.propTypes = {
  classes: PropTypes.object.isRequired,
  addTicketSchema: PropTypes.func.isRequired,
  updateTicketSchema: PropTypes.func.isRequired,
  authUser: PropTypes.object,
  showErrors: PropTypes.func.isRequired,
};

export default _.flow([
  withStyles(styles),
  AuthUserContainer,
  TicketSchemaContainer,
])(SchemaBuilder);
